import React from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';

const MaterialTableDemo = ({colums, tabla,clase,exportExcel, className = '', keyCol=null, addConfig, showFilter=true, onSearch=null, ...rest}) => {
  const config = {
    key_column:keyCol,
    page_size: 10,
    length_menu: [10, 20, 50, 100,500,1000, 10000],
     button: {
       print: false,
       extra: false,
       excel: exportExcel ? true : false
     },
    pagination: 'advance',
    language: {
      length_menu: 'Mostrar _MENU_ registros por página',
      filter: 'Buscar en registros ...',
      info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
      pagination: {
        first: 'Primero',
        previous: <FontAwesomeIcon icon={faArrowAltCircleLeft} /> ,
        next: <FontAwesomeIcon icon={faArrowAltCircleRight} />,
        last: 'Último'
      },
    },
    // intercepta el evento del input de búsqueda de ReactDatatable
    ...(onSearch ? {
      on_change: (_data, event) => {
        if (event && event.target && event.target.type === 'text') {
          onSearch(event);
        }
      }
    } : {}),
    ...addConfig
  };

  const handleChange = onSearch
    ? (data, event) => {
        if (event && event.target && event.target.type === 'text') {
          onSearch(event);
        }
      }
    : undefined;

  return(
      <ReactDatatable
        config={config}
        records={tabla}
        columns={colums}
        show_filter={showFilter}
        show_info={true}
        className={`datatable table-responsive table-striped ${className}`}
        onChange={handleChange}
        {...rest}
      />
  )
}

export default MaterialTableDemo